export * as Api from './api';
export var AmlMatchType;
(function (AmlMatchType) {
    // Name matching types
    AmlMatchType["NameExact"] = "name_exact";
    AmlMatchType["AkaExact"] = "aka_exact";
    AmlMatchType["NameFuzzy"] = "name_fuzzy";
    AmlMatchType["AkaFuzzy"] = "aka_fuzzy";
    AmlMatchType["PhoneticName"] = "phonetic_name";
    AmlMatchType["PhoneticAka"] = "phonetic_aka";
    AmlMatchType["EquivalentName"] = "equivalent_name";
    AmlMatchType["EquivalentAka"] = "equivalent_aka";
    AmlMatchType["Unknown"] = "unknown";
    // Additional matching factors
    AmlMatchType["YearOfBirth"] = "year_of_birth";
    AmlMatchType["RemovedPersonalTitle"] = "removed_personal_title";
    AmlMatchType["RemovedPersonalSuffix"] = "removed_personal_suffix";
    AmlMatchType["RemovedOrganisationPrefix"] = "removed_organisation_prefix";
    AmlMatchType["RemovedOrganisationSuffix"] = "removed_organisation_suffix";
    AmlMatchType["RemovedClericalMark"] = "removed_clerical_mark";
})(AmlMatchType || (AmlMatchType = {}));
//# sourceMappingURL=index.js.map